<template>
  <div>
    <v-row>
      <v-col>
        <v-card class="mb-3" elevation="0">
          <v-card-title class="portal-deep-blue-bg">
            Master Data
          </v-card-title>

          <v-card-text class="mt-5">
            <v-simple-table class="dp-gray" dense>
              <template v-slot:default>
                <thead></thead>
                <tbody>
                  <tr>
                    <th class="text-left shrink" colspan="2">Description</th>
                    <td colspan="2">{{ asset?.asset?.description }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">UIC number</th>
                    <td colspan="2">{{ asset?.asset?.uicnumber }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">Manufacturer</th>
                    <td colspan="2">{{ asset?.asset?.manufacturer }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">
                      Date of Manufacture
                    </th>
                    <td colspan="2">
                      {{ formatdate(asset?.asset?.manufacturerDate) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">Owner</th>
                    <td colspan="2">{{ asset?.asset?.owner }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">Operator</th>
                    <td colspan="2">{{ asset?.asset?.operator?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 1</th>
                    <td colspan="3">{{ asset?.asset?.ecm1?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 2</th>
                    <td colspan="3">{{ asset?.asset?.ecm2?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 3</th>
                    <td colspan="3">{{ asset?.asset?.ecm3?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 4</th>
                    <td class="text-left" colspan="3">
                      {{ asset?.asset?.ecm4?.name }}
                    </td>
                  </tr>

                </tbody>
              </template>
            </v-simple-table>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mb-6" elevation="0">
          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.infoloc.infoOp", { value: "default" }) }}
          </v-card-title>
          <v-card-text class="mt-5">
            <v-simple-table class="dp-gray" dense>
              <template v-slot:default>
                <thead>
                </thead>

                <tbody>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.softwareversion", { value: "default", }) }}
                    </th>
                    <td>{{ asset?.asset?.softwareversion }}</td>
                  </tr>

                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.engineeringvariant", { value: "default", }) }}
                    </th>
                    <td>{{ asset?.asset?.engineeringvariant }}</td>
                  </tr>

                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.page.status", { value: "default" }) }}
                    </th>
                    <td>{{ asset?.asset?.status }}</td>
                  </tr>

                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.magic.restriction", { value: "default" }) }}
                    </th>
                    <td>{{ remark }}</td>
                  </tr>

                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.page.locate", { value: "default" }) }}
                    </th>
                    <td>{{ workorder?.location }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.actWorkorder", { value: "default", }) }}
                    </th>
                    <td>{{ workorder?.description }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.outPrevDate", { value: "default", }) }}
                    </th>
                    <td>{{ formatdate(workorder?.schedfinish) }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.unitToGo", { value: "default" }) }}
                    </th>
                    <td>{{ pleft }}</td>
                  </tr>

                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.nextWorkDate", { value: "default", }) }}
                    </th>
                    <td>{{ formatdate(calcduedate) }}</td>
                  </tr>

                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { formatMagicDate } from "@/shared/DateHelper";

export default {
  components: {
  },
  props: ['asset', 'workorder', 'pleft', 'calcduedate', 'remark'],
  data() {
    return {
    }
  },
  methods: {
    formatdate(date) {
      return formatMagicDate(date, this.$i18n.locale);
    },

  }
}
</script>

<style scoped>
.dates {
  margin-top: 0.5em;
  font-weight: 550;
  color: darkgray;
  font-size: 12px;
  line-height: 12px;
}
</style>